// extracted by mini-css-extract-plugin
module.exports = {"container":"snippet_actions-module__container--3cEHi","button":"snippet_actions-module__button--23ee1","label":"snippet_actions-module__label--2SPUf"};